// Add your custom JS here.

/**
 * Image Slider block — prev/next paging, two images visible at a
 * time. Matches the Insight Hub / Events article slider block
 * registered in inc/acf-blocks.php.
 */
document.addEventListener( 'DOMContentLoaded', function () {
	document.querySelectorAll( '[data-bba-slider]' ).forEach( function ( slider ) {
		var slides = slider.querySelectorAll( '.bba-slider__slide' );
		if ( ! slides.length ) {
			return;
		}

		var prevBtn = slider.querySelector( '[data-slider-prev]' );
		var nextBtn = slider.querySelector( '[data-slider-next]' );
		var offset = 0;

		function render() {
			slides.forEach( function ( slide, i ) {
				slide.style.display = ( i >= offset && i < offset + 2 ) ? 'block' : 'none';
			} );
		}

		if ( prevBtn ) {
			prevBtn.addEventListener( 'click', function () {
				offset = Math.max( 0, offset - 2 );
				render();
			} );
		}

		if ( nextBtn ) {
			nextBtn.addEventListener( 'click', function () {
				offset = Math.min( slides.length - 2, offset + 2 );
				render();
			} );
		}

		render();
	} );
} );
